// MockExamItems — generated mock paper questions, per-paper independent.
//
// Lives on IngestPackage.mockExamItems (optional). One entry in
// MockExamItems.papers[] per CourseDraft.mockPapers[] with matching id.
//
// Why per-paper (vs flat array): mock papers are independent question sets;
// students should NOT see overlap between paper 1 and paper 2 (defeats
// "simulating unfamiliar exam" training value).
//
// Schema reuses Mcq / TrueFalse / Essay schemas — same shape as daily question
// bank, but persisted under a separate top-level field for sampling isolation.
//
// Backward compat: optional. mock-exam-view falls back to pkg.mcqs / pkg.trueFalse
// when this is absent (old IngestPackages keep working with a UI banner saying
// "using daily bank — regenerate to unlock independent mock items").
import { z } from 'zod';
import { McqSchema } from './mcq.js';
import { TrueFalseSchema } from './true-false.js';
import { EssaySchema } from './essay.js';
import { MockPaperStyleSchema } from './mock-paper-style.js';
export const MockExamPaperSchema = z.object({
    /** Matches CourseDraft.mockPapers[].id (paper_1 / paper_2 / paper_3). */
    id: z.string().regex(/^paper_[1-3]$/),
    /** Mirror of CourseDraft.mockPapers[i].style — convenience for UI without lookup. */
    style: MockPaperStyleSchema,
    mcqs: z.array(McqSchema),
    trueFalse: z.array(TrueFalseSchema).optional(),
    essays: z.array(EssaySchema).optional(),
}).passthrough();
export const MockExamItemsSchema = z.object({
    papers: z.array(MockExamPaperSchema),
}).passthrough();
//# sourceMappingURL=mock-exam-items.js.map